import * as types from './mutation-types'
import {REMOVE_ROOM_ORDER_COUNT, REMOVE_ROOM_TABLE_NUMBER} from "./mutation-types";

export default {
    [types.ADD_ROOM] (state, data) {
        state.roomsLoaded = true
        state.rooms.push(data)
    },

    [types.ADD_ROOMS] (state, data) {
        state.roomsLoaded = true
        state.rooms = data
    },

    [types.INCREMENT_ROOM_TABLE_NUMBER] (state, room_id) {
        state.rooms = state.rooms.map((rm) => {
            if(rm.id === room_id){
                let count = rm.tables_count + 1
                rm.tables_count = count > 0 ? count : 0
            }
            return rm
        })
    },

    [types.LOAD_ROOM]: (state, data) => {
        let roomExist = state.rooms.find(x => x.id === data.id)
        if(roomExist){
            state.rooms = state.rooms.map((x) => {
                if(x.id === data.id){
                    return data
                }

                return x
            })
        }else{
            state.rooms.push(data)
        }
    },

    [types.LOAD_ROOMS]: (state, data) => {
        data.forEach((room) => {
            let roomExist = state.rooms.find(x => x.id === room.id)
            if(roomExist){
                state.rooms = state.rooms.map((x) => {
                    if(x.id === room.id){
                        return room
                    }
    
                    return x
                })
            }else{
                state.rooms.push(room)
            }
        })
        
    },

    [types.INCREMENT_ROOM_ORDER_COUNT] (state, tables) {
        let rooms = tables.map(table => table.room_id)
        state.rooms = state.rooms.map((rm) => {
            if(rooms.includes(rm.id)){
                let count = rm.new_orders_count + 1
                rm.new_orders_count = count > 0 ? count : 0
            }

            return rm
        })
    },

    [types.REMOVE_ROOM_ORDER_COUNT] (state, data) {
        let rooms = data?.tables?.map(table => table.room_id) || []
        state.rooms = state.rooms.map((rm) => {
            if(rooms?.includes(rm.id)){
                let count = rm.new_orders_count - (data?.count ?? 0)
                rm.new_orders_count = count > 0 ? count : 0
            }

            return rm
        })
    },

    [types.REMOVE_ROOM_TABLE_NUMBER] (state, data) {
        state.rooms = state.rooms.map((rm) => {
            if(rm.id === data.room_id){
                let count = rm.tables_count - (data?.count - 1 )
                rm.tables_count = count > 0 ? count : 0

            }

            return rm
        })
    },

    [types.ADD_ROOM_TABLE_NUMBER] (state, data) {
        state.rooms = state.rooms.map((rm) => {
            if(rm.id === data.room_id){
                let count = rm.tables_count + (data?.count - 1 )
                rm.tables_count = count > 0 ? count : 0
            }

            return rm
        })
    },





}


